import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useOnboardingStore } from "@/modules/onboarding/onboardingStore";
import { PlanSettingsSection } from "./PlanSettingsSection";
import { ScheduleEditorSection } from "./ScheduleEditorSection";
import { TasksEditorSection } from "./TasksEditorSection";
import { AnnouncementsEditorSection } from "./AnnouncementsEditorSection";

/**
 * The Onboarding settings tab: configures the organization's onboarding plan
 * and go-live schedule. Task and announcement editors live in their own
 * sections alongside these.
 */
export function OnboardingSettingsPanel() {
  const isLoadingBoard = useOnboardingStore((state) => state.isLoadingBoard);
  const boardLoaded = useOnboardingStore((state) => state.boardLoaded);
  const boardError = useOnboardingStore((state) => state.boardError);
  const fetchBoard = useOnboardingStore((state) => state.fetchBoard);
  const plan = useOnboardingStore((state) => state.plan);

  useEffect(() => {
    fetchBoard();
  }, [fetchBoard]);

  if (isLoadingBoard && !boardLoaded) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (boardError) {
    return (
      <Card>
        <CardContent className="flex items-center justify-between py-8">
          <span className="text-sm text-muted-foreground">{boardError}</span>
          <Button variant="outline" size="sm" onClick={() => fetchBoard()}>
            Retry
          </Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <PlanSettingsSection />
      {plan && (
        <>
          <ScheduleEditorSection />
          <TasksEditorSection />
          <AnnouncementsEditorSection />
        </>
      )}
    </div>
  );
}
